import React from 'react';
import TextComponent from 'pu-react/components/TextComponent';

const BgaPlacements = () => {
  return (
    <TextComponent
      label="BGA <br /> Placements"
      value={'Not supported'}
      inputClassName="text-danger"
      groupName={null}
      data={{ readOnly: true }}
    />
  );
};

export default BgaPlacements;
